import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="md:col-span-1">
              <Link to="/" className="font-heading text-xl tracking-wide text-foreground-900">
                幼水若若
              </Link>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                以柔克刚，如幼水般温润流淌。
                <br />
                让每一寸肌肤都被温柔以待。
              </p>
            </div>

            {/* Products */}
            <div>
              <h4 className="text-sm font-medium text-foreground-800 mb-4">产品系列</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/ruoruo-series" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  若若系列
                </Link>
                <Link to="/category/youshui-series" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  幼水系列
                </Link>
                <Link to="/category/limited-collection" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  限定系列
                </Link>
              </div>
            </div>

            {/* Links */}
            <div>
              <h4 className="text-sm font-medium text-foreground-800 mb-4">了解更多</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  关于我们
                </Link>
                <Link to="/articles" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  灵感笔记
                </Link>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-medium text-foreground-800 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5">
                <a href="mailto:hello@youshuiruoruo.com" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  hello@youshuiruoruo.com
                </a>
                <span className="text-sm text-foreground-500">400-888-XXXX</span>
                <div className="flex items-center gap-4 mt-2">
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-500 transition-colors duration-200" aria-label="小红书">
                    <i className="ri-red-packet-line text-sm"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 幼水若若 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}